import { i } from '../lit-element.js';

const radioButtons = i`
  .grv-radio {
    box-sizing: border-box;
    left: 6px;
    margin: 0;
    opacity: 1;
    padding: 0;
    position: absolute;
    top: 6px;
  }

  .grv-radio:focus {
    outline: -webkit-focus-ring-color auto 1px;
    outline-offset: -3px;
  }

  .grv-radio:hover + .grv-radio-label::before,
  .grv-radio:focus + .grv-radio-label::before {
    border: 2px solid #255f82;
  }

  .grv-radio:checked + .grv-radio-label::before {
    border: 8px solid #255f82;
  }

  .grv-radio:checked:hover + .grv-radio-label::before,
  .grv-radio:checked:focus + .grv-radio-label::before {
    border-color: #10253f;
  }

  .grv-radio + .grv-radio-label {
    display: inline-block;
    line-height: 24px;
    padding-left: 40px;
    position: relative;
  }

  .grv-radio + .grv-radio-label::before,
  .grv-radio + .grv-radio-label::after {
    content: '';
    display: inline-block;
    height: 24px;
    left: 0;
    position: absolute;
    top: 0;
    width: 24px;
  }

  .grv-radio + .grv-radio-label::before {
    background: #fff;
    border: 1px solid #696969;
    border-radius: 50%;
    box-sizing: border-box;
    margin-right: 16px;
  }

  .grv-radio-helper {
    color: #141414;
    display: block;
    font-size: 12px;
    margin-top: 8px;
    padding-left: 40px;
  }
`;

export { radioButtons };
